import React from 'react';
import ImageLoader from 'react-load-image';
import PropTypes from 'prop-types';

import Loader from 'components/vistaprintUILibrary/Loader';

function ImagePreloader(props) {
  const {
    style,
    width,
    height,
    ...restProps
  } = props;

  return (
    <div
      {...restProps}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        width,
        height,
        ...style,
      }}
    >
      <Loader />
    </div>
  );
}

ImagePreloader.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  style: PropTypes.object,
};

function ImageError(props) {
  const {
    style,
    height,
    width,
    message,
    ...restProps
  } = props;

  return (
    <div
      {...restProps}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #eeeeee',
        backgroundColor: 'white',
        height,
        width,
        ...style,
      }}
    >
      <div style={{
        color: '#eeeeee',
      }}>{message}</div>
    </div>
  );
}

ImageError.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  message: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export default function ImageWithSize(props) {
  const {
    src,
    alt,
    width,
    height,
    errorMessage = 'Whoops!',
    style,
    ...restProps
  } = props;

  return (
    <ImageLoader
      src={src}
    >
      <img
        style={{
          userSelect: 'none',
          width: 'auto',
          height: 'auto',
          maxHeight: 'inherit',
          maxWidth: 'inherit',
          ...style,
        }}
        alt={alt}
        {...restProps}
      />

      <ImageError
        width={width}
        height={height}
        message={errorMessage}
        style={style}
        {...restProps}
      />
      <ImagePreloader
        width={width}
        height={height}
        style={style}
        {...restProps}
      />
    </ImageLoader>
  );
}

ImageWithSize.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  errorMessage: PropTypes.string,
  style: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/media/ImageWithSize.js